import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Modal } from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { handleSuspended } from '../../../../../../../actions/saleActions';
import { doAcceptOfferRequest } from '../../../../../../../actions/offerAction';
import {
  emptyImage,
  getCloudImageUrl,
} from '../../../../../../../utils';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  dustBag,
  formatCurrency,
  handbagCondition,
  sneakersCondition,
  sneakersDefect,
  displayItem,
  yellowing,
  sneakerDefectsCondition,
  convertToRupiah,
  handleStatusConsignment,
  handleColorStatusConsignment,
} from '../../../../../../../utils/Helpers';
import { isNumeric } from '../../../../../../../helpers/regex';
import { OFFER_GAP, VALIDATE_AMOUNT_DELAY } from '../../../../../../../config';

import { ModalAlert } from '../../../../../../../components/Modals';


const fixingAmount = (value: any | number) => {
  if (isNumeric(value)) {
    let parsed = parseFloat(value);
    parsed -= value % OFFER_GAP;
    const summary = parsed + OFFER_GAP;
    const multipleGAP = value % OFFER_GAP;

    return parsed < OFFER_GAP
      ? OFFER_GAP
      : multipleGAP === 0
      ? parsed
      : summary;
  }
  return value;
};

interface ModalActive {
  isOpen: boolean;
  ratio: number;
  currency: string;
  data: [];
  onToggle: () => any;
  doChangePrice: (idSale, body) => Promise<any>;
  doAcceptOffer: (query, payload) => Promise<any>;
  callbackAfterUpdate: () => void;
  type: string;
}

function ModalActiveComponent({
  isOpen,
  onToggle,
  ratio,
  currency,
  data,
  doChangePrice,
  suspended,
  doAcceptOffer,
  callbackAfterUpdate,
  type,
}) {
  // ============== Start of updated current selling state data ==============
  const [currentAmount, setCurrentAmount] = useState<number>(0);
  const [error, setError] = useState<any>({});
  const [submitPrice, setSubmitPrice] = useState(false);
  const [_openModalWarning, set_openModalWarning] = useState(false);
  const [submitConfirmation, setSubmitConfirmation] = useState(false);

  // ============== End of updated current selling state data ==============

  useEffect(() => {
    let errorTxt = '';
    let isError = false;
    if (currentAmount === 0 || !currentAmount) {
      isError = true;
      errorTxt = 'Please fill in the amount of your asking price.';
    } else if (!isNumeric(currentAmount)) {
      isError = true;
      errorTxt = 'This field must be numeric.';
    }
    setError({
      ...error,
      askingPrice: { isError, text: errorTxt },
    });
  }, [currentAmount]);

  // ============== Start of amount text input method helper ==============
  const [intervalKeyDown, setIntervalKeyDown] = useState(undefined);
  const onFixingAmount = (val: number) => {
    setCurrentAmount(fixingAmount(val));
  };
  const onChangeAmount = (e: any) => {
    let dataAmount = currentAmount;
    dataAmount = parseInt(
      e.target.value
        ? `${e.target.value.replace(/[\. ,:-]+/g, '')}.00`
        : '0.00',
    );
    setCurrentAmount(dataAmount);
    if (intervalKeyDown) clearTimeout(intervalKeyDown);
    const newIntervalKeyUp = setTimeout(() => {
      onFixingAmount(dataAmount);
      setIntervalKeyDown(undefined);
    }, VALIDATE_AMOUNT_DELAY);
    setIntervalKeyDown(newIntervalKeyUp);
  };

  const onBlur = () => {
    if (intervalKeyDown) clearTimeout(intervalKeyDown);
    setIntervalKeyDown(undefined);
    onFixingAmount(currentAmount);
  };
  // ============== End of amount text input method helper ==============

  const _modalWarningToggle = () => {
    set_openModalWarning(!_openModalWarning);
  };

  useEffect(() => {
    if (data) {
      setCurrentAmount(parseInt(data.asking_price))
    }
  }, [data])

  useEffect(() => {
    if (isOpen) {
      setCurrentAmount(parseInt(data.asking_price));
    }
  }, [isOpen]);

  // If data is available, then show the modal
  if (data) {
    const isSameAsBefore = currentAmount === parseInt(data?.asking_price);
    const isDefects = data?.defects?.length > 0
    const uniqueDefects = _.uniqBy(
      isDefects ? data?.defects : null,
      'name',
    );
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG' && a.value)
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = data?.product_variant?.hide_box_info;
    const isVintage = data?.product_variant?.vintage;
    const sneakersDetailArr = [
      isVintage? "Vintage" : sneakersCondition(data?.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(data?.box_condition),
      accessoriesCondition(data?.missing_accessories),
      yellowing(data?.yellowing),
      displayItem(data?.display_item),
      sneakersDefect(data?.sneakers_defect), 
      isDefects ? sneakerDefectsCondition(uniqueDefects, ', ') : ''
    ];
    const sneakersDetail = sneakersDetailArr.filter((item) => item !== '')
      .map((items) => items)
      .join(', ');
    const luxuryDetailArr = [
      sneakersCondition(data?.sneakers_condition),
      accessoriesCondition(data?.missing_accessories),
      dustBag(dustBagCondition),
      hideBoxInfo ? '' : boxHandbag(boxConditions),
      isDefects ? handbagCondition(uniqueDefects, ', ') : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(', ');
    const category = data?.product_variant?.product?.category.name;
    const imageUrl = data?.product_variant?.product_variant_images?.length
      ? data?.product_variant?.product_variant_images[0].URL
      : null;
    const txtStatus = handleStatusConsignment(data, type);
    const isGreenStatus = handleColorStatusConsignment(txtStatus) === '#159953'
    const isYellowStatus = handleColorStatusConsignment(txtStatus) === '#FFCA25'

    const onSave = () => {
      if (!isSameAsBefore) {
        setSubmitPrice(true);
        const payload = {
          status: data.status,
          asking_price: currentAmount,
        };
        doChangePrice(data.id, payload).then(() => {
          onToggle();
          callbackAfterUpdate();     // refetch list
          setSubmitPrice(false);
        })
        .catch((e) => {
          const errorMessage = suspended.error ? suspended.error.message : e
          setSubmitPrice(false)
          toast.error(`${errorMessage}`,
            {
              position: 'top-right',
              autoClose: 5000,
              closeOnClick: true,
              pauseOnHover: true,
            },
          )
        });
      }
    };

    const onConfirmModal = () => {
      setSubmitConfirmation(true);
      _modalWarningToggle();
      const payload = {
        bid_id: parseInt(data.highest_bid.id),
      };

      doAcceptOffer(data.id, payload).then(() => {
        onToggle();
        callbackAfterUpdate();     //refetch list
        setSubmitConfirmation(false);
      });
    };

    const onSellNow = () => {
      if (data.highest_bid) {
        _modalWarningToggle();
      }
    };

    return (
      <Modal
        className="offer-detail-modal"
        toggle={onToggle}
        isOpen={isOpen}
        centered
      >
        <>
          <div className={'content-modal'}>
            <div className={'header-section'}>
              <div className={'left'}>
                <p className={'product-title'}>
                  {data?.product_variant?.display_name}
                </p>
                <p className={'product-sku'}>{data?.product_variant?.SKU}</p>
              </div>
              <div className={'right'}>
                <div>
                  {category === 'handbags' ||
                  (category === 'lifestyles' &&
                    data?.size?.US.toLowerCase() !== 'all size') ? (
                    <div className={'size-container'}>
                      <p>{data?.size?.US}</p>
                    </div>
                  ) : (
                    <div className={'size-container'}>
                      <p>US {data?.size?.US}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={'image-section'}>
              <img
                src={
                  imageUrl
                    ? getCloudImageUrl(imageUrl, 300)
                    : emptyImage(category)
                }
              />
            </div>
            <div className={classNames("status-section", { 'green': isGreenStatus, 'yellow': isYellowStatus })}>
              <p>{txtStatus}</p>
            </div>
            <div className={'grey-box-section'}>
              <div className={'container-row'}>
                <div className={'item'}>
                  <p className={'title'}>Consignment ID</p>
                  <p className={'value'}>{data?.consignment_id}</p>
                </div>
              </div>
              <div className={'container-row'}>
                <div className={'item'}>
                  <p className={'title'}>Date Listed</p>
                  <p className={'value'}>
                    {data?.sell_consignments
                      ? moment(data?.sell_consignments?.created_at).format('MMMM DD, YYYY')
                      : '-'}
                  </p>
                </div>
              </div>
              <div className={'container-row'}>
                <div className={'item'}>
                  <p className={'title'}>Product Conditions</p>
                  <p className={'value'}>
                    {category === 'handbags'
                      ? luxuryDetail
                      : sneakersDetail}
                  </p>
                </div>
              </div>
              {data?.hypequarter_display && (
                <div className={'hq-wrapper'}>
                  <p className={'hq-text'}>Hypequarter Display</p>
                </div>
              )}
            </div>

            <div className={'selling-section'}>
              <p className={'consignment-price'}>Consignment Price</p>
              <div className={'price-container'}>
                <p className={'currency'}>{currency}</p>
                <CurrencyFormat
                  decimalSeparator={','}
                  thousandSeparator={'.'}
                  value={convertToRupiah(currentAmount)}
                  // name={'offerAmount'}
                  onChange={onChangeAmount}
                  onBlur={onBlur}
                  disabled={data?.status === 'under_reservation'}
                />
                <div
                  className={`button-save`}
                  onClick={onSave}
                >
                  <p>{submitPrice ? 'Submitting...' : 'Save Changes'}</p>
                </div>
              </div>
            </div>

            <div className={'price-seller-section'}>
              <div className={'lowest'}>
                <p className={'title'}>Lowest Price</p>
                <p className={'value'}>
                  {formatCurrency(data?.lowest_ask, ratio, currency)}
                </p>
              </div>
              <div className={'highest'}>
                <p className={'title'}>Highest Offer</p>
                <p className={'value'}>
                  {formatCurrency(
                    data?.highest_bid ? data?.highest_bid.amount : 0,
                    ratio,
                    currency,
                  )}
                </p>
              </div>
              <div
                className={`sell ${!data?.highest_bid ? 'disabled' : ''}`}
                onClick={onSellNow}
              >
                <p>Sell Now</p>
              </div>
            </div>

            <p className={'bottom-text'}>
              By clicking SELL NOW, you have agreed to the HIGHEST OFFER price.
              The order will be placed and a notification will be sent to the
              potential buyer to complete the payment. Should the payment
              process fail, your listing will be automatically adjusted that
              amount.
            </p>

            <ModalAlert
              isOpen={_openModalWarning}
              onToggle={_modalWarningToggle}
              title={''}
              contentText={'Are you sure want to accept this offer?'}
              showButton
              onSubmit={onConfirmModal}
            />

          </div>
        </>
      </Modal>
    )
  }
  // Not rendering the modal component is data is unavailable to prevent undefined error
  return <div />;
}

const mapStateToProps = (state) => {
  return {
    currency: state.dataAuth.userCurrency.currency,
    ratio: state.dataAuth.userCurrency.ratio,
    suspended: state.dataSelling.suspended
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doAcceptOffer: (query, payload) =>
      dispatch(doAcceptOfferRequest(query, payload)),
    doChangePrice: (idSale, body) =>
      dispatch(handleSuspended(idSale, body)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalActiveComponent);